/* eslint-disable */
import React, { createRef, useState } from 'react';
import { Link } from 'react-router-dom';
import cls from 'classnames';
import PropTypes from 'prop-types';
import { gsap, ScrollToPlugin } from 'gsap/all';
import Fade from 'react-reveal/Fade';
import { Quote } from '~/components/Quote';
import { Img } from '~/components/Elements/Img';
import { Picture } from '~/components/Elements/Picture';
import DataLayer from '~/components/DataLayer';
import isString from '@dcode/is/string/string';
import configData from '~/config/data';
import css from './WhatsappPage.scss';

gsap.registerPlugin(ScrollToPlugin);

const classes = {
  root: css.whatsappPage,
  content: css.whatsappPageContent,
  quote: css.whatsappPageQuote,
  poster: css.whatsappPagePoster,
  posterImage: css.whatsappPagePosterImage,
  wrapper: css.whatsappPageWrapper,
  wrapperPhrase: css.whatsappPageWrapperPhrase,
  wrapperButton: css.whatsappPageWrapperButton,
  button: css.whatsappPageButton,
  isSimple: css.isSimple,
};

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  data: PropTypes.object,
};

const defaultProps = {
  className: '',
  classes,
  data: configData.whatsapp,
};

export function WhatsappPage({ className, classes, data: info, ...props }) {
  const $el = createRef();
  const [data, setData] = useState(info.data);

  const renderPicture = (item, index) => {
		return (
			<Picture
				className={cls(classes.posterPicture)}
				classNameImg={cls(classes.posterImage, 'swiper-lazy')}
				sources={item.poster.sources}
				alt={item.poster.alt}
			/>
		);
  };
  
  const renderImg = (item, index) => {
		return (
			<Img
				className={cls(classes.posterImage, classes.isSimple, 'swiper-lazy')}
				src={item.poster}
				alt={item.alt}
				mode={'cover'}
			/>
		);
  };
  
  const renderPoster = (item, index) => {
		return isString(item.poster) ? renderImg(item, index) : renderPicture(item, index);
	};

  return (
		<section
			ref={$el}
			id={WhatsappPage.displayName}
			data-ui-anchor={WhatsappPage.displayName}
			className={cls(classes.root, className)}>
			{/* Accordion ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
			<Fade>
				<Quote className={classes.quote} title={data.title} text={data.description} />
			</Fade>

      <div className={classes.content}>
        <div className={classes.poster}>
          {renderPoster(data.content)}
        </div>
        <div className={classes.wrapper}>
          <div className={classes.wrapperPhrase}>
            <Fade>
              <h3>Quer tirar dúvidas pelo <br />Whatsapp e ver o carro ao vivo?</h3>
            </Fade>
          </div>
          <div className={classes.wrapperButton}>
						<Fade bottom>
							<DataLayer onEvent={'WhatsappPage_ClicouCompreOSeu'} args={[]}>
                <a className={classes.button} 
                  href="https://wa.me/553121236000?text=Vi%20a%20Nova%20Fiat%20Strada%20no%20website%20e%20quero%20saber%20mais%20detalhes%20da%20picape" 
                  target="_blank">
                  <i className={cls('fa', 'fa-whatsapp')}></i>
                  Falar com especialista
								</a>
							</DataLayer>
						</Fade>
					</div>
        </div>
      </div> */}
		</section>
	);
}

WhatsappPage.displayName = 'WhatsappPage';
WhatsappPage.propTypes = propTypes;
WhatsappPage.defaultProps = defaultProps;
export default WhatsappPage;